<div class="row retiree-deductions nova-font-style">
  <div class="col s12 m10 offset-m1 l8 offset-l2 xl6 offset-xl3 remove-default-padding">
    <h2>Other</h2>
    <div>
      <kendo-tabstrip [animate]="true" [tabAlignment]="'justify'">
        <kendo-tabstrip-tab title="Upload" [selected]="true">
          <ng-template kendoTabContent>
            <div id="upload-form">
              <div class="form-layout top-padding-20">
                <div class="left-margin-10 file-upload">
                  <kendo-upload #myUpload class="kendo-upload" [autoUpload]="false" [saveUrl]="uploadSaveUrl"
                    [multiple]="false" [removeUrl]="uploadRemoveUrl" [restrictions]="config.OtherUploadFileRestrictions"
                    (complete)="uploadComplete(myUpload)" (upload)="uploadEventHandler($event)"
                    (success)="uploadSuccess($event)" (select)="selectEventHandler($event)"
                    (error)="errorEventHandler()">
                    <kendo-upload-messages select="Select a file..">
                    </kendo-upload-messages>
                  </kendo-upload>
                </div>
              </div>
            </div>
          </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab title="History">
          <ng-template kendoTabContent>
            <app-upload-history [fileType]="'Other'"></app-upload-history>
          </ng-template>
        </kendo-tabstrip-tab>
      </kendo-tabstrip>
    </div>
  </div>
</div>
